import React from 'react';
import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import { Values } from '@shared/utils/objectEnums';
import { Currencies } from '@shared/utils/constants';
import NumericInput, { NumericInputProps } from '@client/components/NumericInput';
import { useAuth } from '@client/lib/auth';

export type CurrencyInputProps = {
	currency?: Values<typeof Currencies>;
	addCurrencyBefore?: boolean;
	disabledTooltip?: string | React.ReactElement;
	tooltipProps?: TooltipProps;
	allowNegative?: boolean;
	'data-testid'?: string;
} & NumericInputProps;

const CurrencyInput = ({
	allowNegative = false,
	addCurrencyBefore = true,
	disabledTooltip,
	tooltipProps,
	currency,
	...props
}: CurrencyInputProps) => {
	const { userInfo } = useAuth();

	const content = (
		<NumericInput
			addonBefore={addCurrencyBefore ? (currency ?? userInfo.baseCurrency) : null}
			min={allowNegative ? undefined : 0}
			{...props}
		/>
	);

	if (props.disabled && disabledTooltip != null) {
		return (
			<Tooltip
				title={disabledTooltip}
				{...tooltipProps}
			>
				{content}
			</Tooltip>
		);
	}

	return content;
};

export default CurrencyInput;
